import fetch from '@giro/shared-utils/fetch.util';

export default async function postApiPaymentLinksIdRefreshStatusService(
  id: string
) {
  return fetch(`payment-links/${id}/refresh-status`, {
    method: 'POST',
    ms: 'PDV',
    auth: true,
  });
}
